import { useState, useEffect } from 'react';

export default function useTableMinHeight(containerRef, {
  hasData,
  offsetBottom = 50,
  minPossibleHeight = 144,
}) {
  const [tableMinHeight, setTableMinHeight] = useState(null);

  // If there are no data, stretch the table to fit the viewport's available height
  useEffect(() => {
    let nextMinHeight = null;

    if (!hasData) {
      const containerCoords = containerRef.current.getBoundingClientRect();
      const availableHeight = window.innerHeight - (containerCoords.top + offsetBottom);

      nextMinHeight = availableHeight > minPossibleHeight ? availableHeight : minPossibleHeight;
    }

    setTableMinHeight(nextMinHeight);
  }, [hasData]);

  return tableMinHeight;
}
